import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./login/Login";
import UserDashboard from "./components/user/dashboard/UserDashboard";
import Wapp from "./components/wapp/page";
import Wbtn from "./components/wbtn/page";
import Report from "./components/report/page";
import Transaction from "./components/transaction/page";
import NotificationCard from "./components/notification/page";
import CampaignTable from "./components/campaign/page";
import UserManagementUI from "./components/users/UserManagementUI";

import UserSidebar from "./components/user/dashboard/UserSidebar";
import { isAuthenticated, getRole } from "./utils/auth";
import Edit from "./components/report/edit";
import Notificationform from "./components/notification/form"
import Detail from "./components/campaign/details"
import PageEdit from "./components/campaign/pageedit"
import AddUsers from "./components/users/Addform"
import View from "./components/users/view"
import Validity from "./components/users/validity"
import Whitelist from "./components/users/whitelist"
import Passwoard from "./components/users/password"
import AddCreditForm from "./components/users/AddCredit";

// Protected Route Wrapper
const ProtectedRoute = ({ element, role }) => {
  if (!isAuthenticated()) return <Navigate to="/login" />;
  const userRole = getRole();
  const allowedRoles = Array.isArray(role) ? role : [role];
  if (!allowedRoles.includes(userRole)) return <Navigate to="/login" />;
  return element;
};

// Sidebar Layout
const UserLayout = ({ children }) => (
  <>
    <UserSidebar />
    <div className="mt-4 ml-0  p-4">{children}</div>
  </>
);

const App = () => {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Navigate to="/login" />} />


        <Route path="/login" element={<Login />} />


        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              role={["admin", "user", "subadmin"]}
              element={
                <UserLayout>
                  <UserDashboard />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/wapp"
          element={
            <ProtectedRoute
              // role="admin" // or "user"
              role={["admin", "user", "subadmin"]}
              element={
                <UserLayout>
                  <Wapp />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/wbtn"
          element={
            <ProtectedRoute
              role={["admin", "user", "subadmin"]}
              element={
                <UserLayout>
                  <Wbtn />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute
              role={["admin", "user", "subadmin"]}
              element={
                <UserLayout>
                  <Report />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/edit"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <Edit />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/transaction"
          element={
            <ProtectedRoute
              // role="admin"  // or "user"
              role={["admin", "user", "subadmin"]}
              element={
                <UserLayout>
                  <Transaction />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/notification"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <NotificationCard />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/notification/form"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <Notificationform />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/campaign"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <CampaignTable />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/details"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <Detail />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/pageedit"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  < PageEdit />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <UserManagementUI />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/users/adduser"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <AddUsers />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/users/view"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <View />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/users/validity"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <Validity />
                </UserLayout>
              }
            />
          }
        />

        <Route
          path="/users/whitelist"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <Whitelist />
                </UserLayout>
              }
            />
          }
        />

        <Route
          path="/users/password"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <Passwoard />
                </UserLayout>
              }
            />
          }
        />
        <Route
          path="/users/addcredit"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <AddCreditForm />
                </UserLayout>
              }
            />
          }
        />

        {/* <Route
          path="/users"
          element={
            <ProtectedRoute
              role="admin"
              element={
                <UserLayout>
                  <UserManagementUI />
                </UserLayout>
              }
            />
          }
        /> */}


        {/* 404 Fallback */}
        <Route
          path="*"
          element={<div className="p-8 text-xl">404 - Page Not Found</div>}
        />
      </Routes>
    </Router>
  );
};

export default App;
